import {
  OrderPaymentAdminDto,
  OrderPaymentClientDto,
  PaymentTransactionAdminDto,
  PaymentTransactionClientDto,
} from 'service-api/src/types/api'
import { i18WithDefault as t } from './locales'

export const getPayFacTypeLabel = (
  payFacType?: OrderPaymentClientDto['payFacType'] | OrderPaymentAdminDto['payFacType']
) => {
  if (!payFacType) return ''
  if (payFacType === 'ADYEN' || payFacType === 'TILLED') return t('payment.label.card')
  return t('payment.label.wallet')
}

export const getTxnPayFacTypesApplied = (
  transactions?: PaymentTransactionClientDto[] | PaymentTransactionAdminDto[]
) => {
  if (!transactions) return []
  const payFacTypes = new Set(transactions.map((transaction) => transaction.orderPayment?.payFacType))
  return Array.from(payFacTypes)
}

export const getPaymentPayFacTypesApplied = (payments?: OrderPaymentClientDto[] | OrderPaymentAdminDto[]) => {
  if (!payments) return []
  const payFacTypes = new Set(payments.map((payment) => payment.payFacType))
  return Array.from(payFacTypes)
}

export const getInvoiceTxns = (
  payments?: OrderPaymentClientDto[] | OrderPaymentAdminDto[]
): Map<string | null, PaymentTransactionClientDto[] | PaymentTransactionAdminDto[]> => {
  if (!payments) return new Map()
  const orderTransactions = payments.flatMap(
    (payment) => payment.transactions?.map((transaction) => ({ ...transaction, orderPayment: payment })) || []
  )
  const invoiceTxns = new Map<string | null, PaymentTransactionClientDto[] | PaymentTransactionAdminDto[]>()

  orderTransactions.forEach((txn) => {
    const invoiceTxn = invoiceTxns.get(txn.invoiceId!)

    if (invoiceTxn) {
      invoiceTxn.push(txn)
    } else {
      invoiceTxns.set(txn.invoiceId!, [txn])
    }
  })

  return invoiceTxns
}

export const isDeposit = (payment: OrderPaymentClientDto | OrderPaymentAdminDto) =>
  payment.depositDue !== null && payment.depositDue !== undefined
